export default "__VITE_ASSET__55efceb6__"